import { render } from "./AssignedTaskToResourceGroupTable.vue?vue&type=template&id=136ee99e&scoped=true&ts=true"
import script from "./AssignedTaskToResourceGroupTable.vue?vue&type=script&lang=ts"
export * from "./AssignedTaskToResourceGroupTable.vue?vue&type=script&lang=ts"

import "./AssignedTaskToResourceGroupTable.vue?vue&type=style&index=0&id=136ee99e&scoped=true&lang=css"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-136ee99e"]])

export default __exports__